import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { verifyEmail } from '../services/api';
import { useAuth } from '../components/AuthContext';
import FilledButton from '../components/FilledButton';
import OutlinedButton from '../components/OutlinedButton';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const uidb64 = searchParams.get('uidb64');
  const token = searchParams.get('token');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const { isAuthenticated } = useAuth();

  const called = useRef(false);

  useEffect(() => {
    if (!uidb64 || !token || called.current) return;
    called.current = true;
    verifyEmail(uidb64, token)
      .then(() => {
        setStatus('success');
        setMessage('Email verified!');
      })
      .catch((err) => {
        setStatus('error');
        const code = err.response?.data?.error;
        if (code === 'token_expired' || code === 'token_used' || code === 'invalid_token') {
          setMessage('This link is no longer valid.');
        } else {
          setMessage('Verification link is invalid or has expired.');
        }
      });
  }, [uidb64, token]);

  return (
    <Box sx={{ textAlign: 'center', py: { xs: 6, md: 8 } }}>
      <Typography variant="h4" gutterBottom>
        Verify Email
      </Typography>
      {message && (
        <Typography color={status === 'success' ? 'primary' : 'error'} sx={{ mb: 2 }}>
          {message}
        </Typography>
      )}
      {status === 'error' && (
        <OutlinedButton
          to="/settings"
          text="Resend verification email"
          color="primary"
          sx={{ mr: 2 }}
        />
      )}
      {isAuthenticated ? (
        <FilledButton to="/settings" text="Back to Settings" color="primary" />
      ) : (
        <FilledButton
          component={RouterLink}
          to="/sign-in"
          text="Go to Sign In"
          color="primary"
        />
      )}
    </Box>
  );
}
